import { type VariantProps, cva } from 'class-variance-authority'

export { default as Button } from './Button.vue'
export { default as LoadingButton } from './LoadingButton.vue'

// Shared styles for enhanced button variants
const enhancedButtonBase = 'text-primary-foreground hover:shadow-primary-button-shadow'

export const buttonVariants = cva(
  'select-none cursor-pointer inline-flex items-center justify-center whitespace-nowrap rounded-md font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ring-offset-background text-xs md:text-sm',
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground hover:opacity-[0.9]',
        default2: `bg-primary-button/80 hover:bg-primary-button border-[0.5px] border-white/[.16] hover:border-white/40 active:border-white/80  ${enhancedButtonBase}`,
        'primary-homepage': `bg-primary-homepage-button/80 hover:bg-primary-homepage-button border-[0.5px] border-white/[.16] hover:border-white/40 active:border-white/80 ${enhancedButtonBase} disabled:bg-white/5 disabled:border-none`,
        destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
        outline: 'border border-input bg-background hover:bg-accent hover:text-accent-foreground',
        secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
        secondary2: 'bg-white/5 text-white hover:bg-white/15',
        ghost: 'hover:bg-accent hover:text-accent-foreground',
        ghost2: 'text-secondary-button font-normal hover:text-white/80',
        ghostOutlined:
          'border border-white/5 bg-white/5 hover:bg-white/10 text-secondary-button font-medium hover:text-white/80',
        link: 'text-primary underline-offset-4 hover:underline',
        link2: 'text-[#86BAFF] underline hover:text-[#86BAFF]/80',
        drawer: 'bg-drawerButtonBg rounded-full',
        drawerHighlighted: 'bg-drawerButtonHighlightedBg rounded-full',
        coach: 'bg-coachButtonBg rounded-full text-13 font-normal text-white',
        loginForm: 'w-full bg-loginForm text-white text-base font-medium rounded-full',
        accent: 'bg-highlight hover:opacity-[0.9] text-white',
        priority: `  
          [background-image:linear-gradient(to_right,#005EDA_0%,#005EDA_5%,#F3004E_100%)]
          ring-[0.5px] ring-white/[.16] ring-inset 
          hover:ring-white/40 active:ring-white/80 
          ${enhancedButtonBase}
        `
      },
      size: {
        default: 'h-10 px-4 py-2',
        xs: 'h-7 rounded px-2',
        sm: 'h-9 rounded-md px-3',
        lg: 'h-11 rounded-md px-8',
        xl: 'h-16 rounded-full px-3',
        icon: 'h-10 w-10',
        loginForm: 'p-2'
      }
    },
    defaultVariants: {
      variant: 'default',
      size: 'default'
    }
  }
)

export type ButtonVariants = VariantProps<typeof buttonVariants>
